import {HttpServices} from '../Helpers';

export const GetAllSetupsCareerLevels = async ({
    limit,
    page,
    search,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);

    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/career?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetSetupsCareerLevelsById = async ({uuid}) => {
    const queryList = [];
    if (uuid) queryList.push(`uuid=${uuid}`);

    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/career/view?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const CreateSetupsCareerLevels = async (body) => {
    const result = await HttpServices.post(
        `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/service/career`,
        body,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
export const UpdateSetupsCareerLevels = async (body) => {
    const result = await HttpServices.put(
        `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/service/career`,
        body,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const DeleteSetupsCareerLevel = async (params) => {
    const result = await HttpServices.delete(
        `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/service/career`,
        {
            params,
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
